if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });

        this.querySelector(".quick-add-modal__overlay")?.addEventListener(
          "click",
          this.hide.bind(this, false)
        );
      }

      hide(preventFocus = false) {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = "";
        this.querySelectorAll(
          ".quick-add-modal__content > .product__full-details"
        ).forEach((el) => el.remove());

        $(".js-media-list").each(function () {
          this.swiper?.destroy();
        });
        $(".js-media-sublist").each(function () {
          this.swiper?.destroy();
        });

        if (preventFocus) this.openedBy = null;

        this.classList.remove("active");
        this.setAttribute("aria-hidden", "true");
        super.hide();

        document.body.classList.remove("overflow-hidden-modal");
      }

      show(opener) {
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");

        if (opener.querySelector(".loading-overlay__spinner")) {
          opener
            .querySelector(".loading-overlay__spinner")
            .classList.remove("hidden");
        }

        fetch(opener.getAttribute("data-product-url"))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            this.productElement = responseHTML.querySelector(
              'section[id^="MainProduct-"]'
            );
            this.adoptStylesheets(responseHTML);
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(
              this.modalContent,
              this.productElement.innerHTML,
              opener
            );

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();

            /* One modal serves every card now, so the accessible name has to
               follow whichever product was opened. */
            const dialog = this.querySelector('[role="dialog"]');
            const title = opener.getAttribute("data-product-title");
            if (dialog && title) dialog.setAttribute("aria-label", title);
            this.setAttribute("aria-hidden", "false");

            setTimeout(() => {
              this.classList.add("active");
            });
            super.show(opener);

            /* ModalDialog locks body scroll on show. The quick view should
               leave the page scrollable, so undo it straight after. */
            document.body.classList.remove("overflow-hidden");

            /* Deliberately not locking body scroll - the page should stay
               scrollable behind the quick view. */

            this.querySelector(".read-more-btn")?.addEventListener(
              "click",
              () => {
                this.querySelector(".product__description").classList.toggle(
                  "collapsed"
                );
              }
            );

            const dec = this.querySelector(".product__description");
            if (dec) {
              if (dec.scrollHeight > 250) {
                this.querySelector(".read-more-btn").style.display = "block";
              } else {
                dec.classList.remove("collapsed");
              }
            }

            this.setFocusElement(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");

            if (opener.querySelector(".loading-overlay__spinner")) {
              opener
                .querySelector(".loading-overlay__spinner")
                .classList.add("hidden");
            }

            selectDropDown();
          });
      }

      /* The product section prints its stylesheet links above the <section>
         tag, so taking only the section's innerHTML leaves them behind and the
         modal renders unstyled. Pull over anything the page does not have. */
      adoptStylesheets(doc) {
        const have = new Set(
          Array.from(document.querySelectorAll('link[rel="stylesheet"]')).map(
            (link) => link.getAttribute("href")
          )
        );
        doc.querySelectorAll('link[rel="stylesheet"]').forEach((link) => {
          const href = link.getAttribute("href");
          if (!href || have.has(href)) return;
          const copy = document.createElement("link");
          copy.rel = "stylesheet";
          copy.href = href;
          document.head.appendChild(copy);
          have.add(href);
        });
      }

      setInnerHTML(element, html, opener) {
        element.innerHTML = html;

        element.querySelectorAll("script").forEach((oldScriptTag) => {
          const newScriptTag = document.createElement("script");
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(
            document.createTextNode(oldScriptTag.innerHTML)
          );
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });

        /* "View full details" sits in the panel's own footer, outside the
           scrolling area. Inside it, a product with variant pickers pushed it
           below the fold and you had to scroll to find the way out. */
        const shell = this.querySelector(".quick-add-modal__content");
        const existing = shell && shell.querySelector(":scope > .product__full-details");
        if (existing) existing.remove();

        const moreBtn = document.createElement("a");
        moreBtn.innerHTML = `<span>${theme.quickviewMore}</span>`;
        moreBtn.setAttribute("href", opener.getAttribute("data-product-url"));
        moreBtn.setAttribute(
          "class",
          "product__full-details button button--simple"
        );

        if (shell) {
          shell.appendChild(moreBtn);
        } else if (element.querySelector(".product__info-container")) {
          element.querySelector(".product__info-container").appendChild(moreBtn);
        }
      }

      removeDOMElements() {
        const modal = this.productElement.querySelector("product-modal");
        if (modal) modal.remove();

        const breadcrumb = this.productElement.querySelector(".breadcrumb");
        if (breadcrumb) breadcrumb.remove();

        /* The section prints its own breadcrumb under a different class. */
        this.productElement
          .querySelectorAll(".product__breadcrumb, .breadcrumbs-wrapper")
          .forEach((el) => el.remove());

        /* Decorative band that sits under the page content. It has nothing to
           show inside the modal and renders as an empty grey bar. */
        this.productElement
          .querySelectorAll(".product__bottom-info")
          .forEach((el) => el.remove());

        const popup = this.productElement.querySelectorAll(".product-popup");
        popup.forEach((el) => {
          el.remove();
        });

        const sku = this.productElement.querySelector(".product__sku");
        if (sku) sku.remove();

        const about = this.productElement.querySelectorAll(".about");
        about.forEach((el) => {
          el.remove();
        });

        const customLiquid =
          this.productElement.querySelectorAll(".custom-liquid");
        customLiquid.forEach((el) => {
          el.remove();
        });

        const shareButtons =
          this.productElement.querySelector(".share-buttons");
        if (shareButtons) shareButtons.remove();

        const tags = this.productElement.querySelector(".product-tags");
        if (tags) tags.remove();

        const pickupAvailability = this.productElement.querySelector(
          ".pickup-availability"
        );
        if (pickupAvailability) pickupAvailability.remove();

        const notify = this.productElement.querySelector(".notify-button");
        if (notify) notify.remove();

        const floatedForm = this.productElement.querySelector(".floated_form");
        if (floatedForm) floatedForm.remove();

        const complementaryProducts = this.productElement.querySelector(
          ".complementary-products"
        );
        if (complementaryProducts) complementaryProducts.remove();

        const modalVariants =
          this.productElement.querySelector(".modal-opener-main");
        if (modalVariants) modalVariants.remove();

        const popupVariantFieldset = this.productElement.querySelectorAll(
          ".popup_variant_fieldset"
        );
        popupVariantFieldset.forEach((el) => {
          el.classList.remove("popup_variant_fieldset");
        });

        const parent = this.productElement.querySelector(
          ".product-variant-popup-modal"
        );
        if (parent && parent.parentNode) {
          while (parent.firstChild) {
            parent.parentNode.insertBefore(parent.firstChild, parent);
          }
          parent.remove();
        }

        const productMain = this.productElement.querySelector(".product__main");
        const description = this.productElement.querySelector(
          ".product__description"
        );

        if (description) {
          productMain.appendChild(description);
          const btn = this.productElement.querySelector(".read-more-btn");
          productMain.appendChild(btn);
        }

        const productMedia =
          this.productElement.querySelector(".quick-add-info");
        const productText = this.productElement.querySelector(".product__text");
        const productTitle =
          this.productElement.querySelector(".product__title");
        const price = this.productElement.querySelector(".price-wrapper");
        const tax = this.productElement.querySelector(".product__tax");

        if (productText) productMedia.appendChild(productText);
        if (productTitle) productMedia.appendChild(productTitle);
        if (price) productMedia.appendChild(price);
        if (tax) productMedia.appendChild(tax);

        const productMediaList = this.productElement.querySelector(
          ".product__media-list"
        );
        if (productMediaList)
          productMediaList.classList.remove("swiper", "js-media-list");

        const productMediaItems = this.productElement.querySelector(
          ".product__media-items-wrapper"
        );
        if (productMediaItems)
          productMediaItems.classList.remove("swiper-wrapper");

        const productMediaItem = this.productElement.querySelector(
          ".product__media-item"
        );
        if (productMediaItem) productMediaItem.classList.remove("swiper-slide");
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML =
          this.productElement.innerHTML.replaceAll(
            sectionId,
            `quickadd-${sectionId}`
          );
        this.productElement
          .querySelectorAll("variant-selects, variant-radios")
          .forEach((variantSelect) => {
            variantSelect.dataset.originalSection = sectionId;
          });
      }

      preventVariantURLSwitching() {
        if (this.modalContent.querySelector("variant-radios,variant-selects")) {
          this.modalContent
            .querySelector("variant-radios,variant-selects")
            .setAttribute("data-update-url", "false");
        }
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector(
          '[id^="Slider-Gallery"]'
        );
        if (!galleryList) return;

        galleryList.setAttribute("role", "presentation");
        galleryList
          .querySelectorAll('[id^="Slide-"]')
          .forEach((li) => li.setAttribute("role", "presentation"));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector(".product");
        const desktopColumns = product.classList.contains("product--columns");
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll(".product__media img");
        if (!mediaImages.length) return;

        let mediaImageSizes =
          "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";

        if (product.classList.contains("product--medium")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "605px");
        } else if (product.classList.contains("product--small")) {
          mediaImageSizes = mediaImageSizes.replace("715px", "495px");
        }

        mediaImages.forEach((img) =>
          img.setAttribute("sizes", mediaImageSizes)
        );
      }

      setFocusElement(opener) {
        const productCard = opener.closest(".card-wrapper");
        const productCardLink = productCard?.querySelector(
          ".card-wrapper__link--overlay"
        );
        if (productCardLink) this.openedBy = productCardLink;
      }
    }
  );
}
